import { Controller } from "stimulus";

const $ = window.jQuery;

// Search Input Controller
//
// Responsibility:
// - Expand and shrink width of the search input container
//
export default class extends Controller {
  connect() {
    this.isNotMobile = $(this.element).css("max-width") !== "none";
    this.originalWidth = this.data.get("originalWidth") || "270px";
    this.expandedWidth = this.data.get("expandedWidth") || "500px";
    this.speed = 400; // Animation speed
  }

  // Expand container width
  expand() {
    if (this.isNotMobile) {
      $(this.element).animate(
        { maxWidth: this.expandedWidth },
        this.speed,
        "easeOutBack",
      );
    }
  }

  // Shrink container width
  shrink() {
    if (this.isNotMobile) {
      $(this.element).animate(
        { maxWidth: this.originalWidth },
        this.speed,
        "easeOutQuart",
      );
    }
  }
}
